export default __webpack_public_path__ + "img/blue-circle.65f09dad.png";